var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	1174: {
		fallback: () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(7294))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.3.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	9486: {
		fallback: () => (__webpack_require__.e(935).then(() => (() => (__webpack_require__(3935))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.3.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	9390: {
		fallback: () => (__webpack_require__.e(788).then(() => (() => (__webpack_require__(2788))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.3.11",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-components",

	},
	5487: {
		fallback: () => (__webpack_require__.e(427).then(() => (() => (__webpack_require__(8427))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.16.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "kubra-ui-lib-auth",

	},
	6209: {
		fallback: () => (Promise.all([__webpack_require__.e(173), __webpack_require__.e(328)]).then(() => (() => (__webpack_require__(7814))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^0.2.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@fortawesome/react-fontawesome",

	},
	1018: {
		fallback: () => (Promise.all([__webpack_require__.e(97), __webpack_require__.e(880)]).then(() => (() => (__webpack_require__(3880))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^0.3.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@honeycombio/opentelemetry-web",

	},
	171: {
		fallback: () => (Promise.all([__webpack_require__.e(97), __webpack_require__.e(661)]).then(() => (() => (__webpack_require__(7661))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^0.40.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@opentelemetry/auto-instrumentations-web",

	},
	7454: {
		fallback: () => (__webpack_require__.e(557).then(() => (() => (__webpack_require__(6557))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.15.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "axios",

	},
	3976: {
		fallback: () => (__webpack_require__.e(808).then(() => (() => (__webpack_require__(7808))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.0.0-rc.4",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "kubra-ui-lib-feature-flag",

	},
	6192: {
		fallback: () => (Promise.all([__webpack_require__.e(151), __webpack_require__.e(740)]).then(() => (() => (__webpack_require__(151))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.19.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "kubra-ui-lib-mfe",

	},
	276: {
		fallback: () => (__webpack_require__.e(346).then(() => (() => (__webpack_require__(1346))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.44.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "kubra-ux-forge",

	},
	142: {
		fallback: () => (__webpack_require__.e(630).then(() => (() => (__webpack_require__(4511))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^4.0.12",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react-error-boundary",

	},
	9173: {
		fallback: () => (__webpack_require__.e(382).then(() => (() => (__webpack_require__(9382))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^6.2.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@fortawesome/fontawesome-svg-core",

	},
	2442: {
		fallback: () => (__webpack_require__.e(291).then(() => (() => (__webpack_require__(3291))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^5.3.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "history",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"98": [
		6209,
		1018,
		171,
		7454,
		3976,
		6192,
		276,
		142
	],
	"173": [
		9173
	],
	"174": [
		1174
	],
	"390": [
		9390
	],
	"486": [
		9486
	],
	"487": [
		5487
	],
	"740": [
		2442
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}